var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('v-container',[_vm._v(_vm._s(_vm.items))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }